
import { convertHTMLEntitiesToCharacters, removeVietnameseTones } from '@/utils/utils'

export default {
  name: 'AppendixBlog',
  props: {
    listContent: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      indexActive: 0
    }
  },
  methods: {
    emitIndex(index) {
      this.indexActive = index
      window.location.hash = removeVietnameseTones(convertHTMLEntitiesToCharacters(this.listContent[index])).replaceAll(' ', '_')
      this.$emit('emitIndex', index + 1)
    }
  }
}
